import styled from "styled-components";
import footerImage from "assets/img/footer_back.jpg";
import { Link } from "react-router-dom";
import { theme } from "styles/mui-config";
import IconButton from "@mui/material/IconButton";

export const MainFooter = styled.div`
  background-image: url(${footerImage});
  background-color: ${theme.palette.primary.dark};
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  @media (max-width: 899.9px) {
    margin-bottom: 60px;
  }
`;
export const CopyRight = styled.div`
  background-color: transparent;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid #ffffff99;
  text-align: center;
  direction: rtl;

  & img {
    width: 28px !important;
    margin-left: 5px;
    margin-top: 5px;
  }
  }
  & a {
    font-size: 15px;
    // font-weight: bold;
    margin-top: 10px;
    margin: 0;
    color: white !important;
  }
  @media (max-width: 900px) {
    padding: 15px;
    & a {
      font-size: 14px;
    }
  }
`;

export const StyledContainerFooter = styled.div`
  padding-top: 40px;
  width: 100%;
  padding-bottom: 40px;
  @media (max-width: 900px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

export const StyledfooterH4 = styled.h4`
  color: white;
  font-size: 19px;
  font-family: "Avini";
  margin: 0;
  font-size: 29px;
  @media (max-width: 900px) {
    font-size: 26px;
  }
`;

export const StyledfooterH5 = styled.h5`
  color: white;
  font-family: "Avini";
  margin: 0;
  font-size: 25px;
  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

export const Styledp = styled.p`
  color: white;
  padding-left: 63px;
  text-align: justify;
  @media (max-width: 900px) {
    padding-left: 0px;
  }
`;

export const Styledol = styled.ol`
  list-style: circle;
  color: white;
  padding-right: 15px;
  & li {
    margin-bottom: 10px;
  }
  & li > a {
    color: white;
  }
`;

export const StyledLink = styled(Link)`
  color: white !important;
  font-size: 17px;
`;

export const StyledIconButton = styled(IconButton)`
  margin-left: 10px !important;
  margin-bottom: 10px !important;
  & > a {
    display: flex;
  }
`;
